/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React from "react"
import Tippy from "@tippyjs/react"

interface IProps {
  children: React.ReactNode
  content: React.ReactNode
  placement: "top" | "top-start" | "top-end" | "bottom-start"
  visible?: boolean
  interactive?: boolean
}
export function ToolTip({ children, content, placement, visible, interactive }: IProps) {
  return (
    <Tippy
      interactive={interactive}
      visible={visible}
      content={content}
      popperOptions={{
        strategy: "fixed",
      }}
      appendTo="parent"
      css={css`
        &.tippy-box[data-animation="fade"][data-state="hidden"] {
          opacity: 0;
        }
        [data-tippy-root] {
          max-width: calc(100vw - 10px);
        }
        &.tippy-box {
          position: relative;
          background-color: #333;
          color: #fff;
          border-radius: 4px;
          font-size: 14px;
          line-height: 1.4;
          outline: 0;
          transition-property: transform, visibility, opacity;
          transition-duration: 1ms;
        }
        &.tippy-box[data-placement^="top"] > .tippy-arrow {
          bottom: 0;
        }
        &.tippy-box[data-placement^="top"] > .tippy-arrow:before {
          bottom: -7px;
          left: 0;
          border-width: 8px 8px 0;
          border-top-color: initial;
          transform-origin: center top;
        }
        &.tippy-box[data-inertia][data-state="visible"] {
          transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);
        }
        .tippy-arrow {
          width: 16px;
          height: 16px;
          color: #333;
        }
        .tippy-arrow:before {
          content: "";
          position: absolute;
          border-color: transparent;
          border-style: solid;
        }
        .tippy-content {
          position: relative;
          padding: 5px 9px;
          z-index: 1;
        }
        &.tippy-box[data-animation="perspective"][data-placement^="top"] {
          transform-origin: bottom;
        }
        &.tippy-box[data-animation="perspective"][data-placement^="top"][data-state="visible"] {
          transform: perspective(700px);
        }
        &.tippy-box[data-animation="perspective"][data-placement^="top"][data-state="hidden"] {
          transform: perspective(700px) translateY(8px) rotateX(60deg);
        }
        &.tippy-box[data-animation="perspective"][data-placement^="bottom"] {
          transform-origin: top;
        }
        &.tippy-box[data-animation="perspective"][data-placement^="bottom"][data-state="visible"] {
          transform: perspective(700px);
        }
        &.tippy-box[data-animation="perspective"][data-placement^="bottom"][data-state="hidden"] {
          transform: perspective(700px) translateY(-8px) rotateX(-60deg);
        }
        &.tippy-box[data-animation="perspective"][data-placement^="left"] {
          transform-origin: right;
        }
        &.tippy-box[data-animation="perspective"][data-placement^="left"][data-state="visible"] {
          transform: perspective(700px);
        }
        &.tippy-box[data-animation="perspective"][data-placement^="left"][data-state="hidden"] {
          transform: perspective(700px) translateX(8px) rotateY(-60deg);
        }
        &.tippy-box[data-animation="perspective"][data-placement^="right"] {
          transform-origin: left;
        }
        &.tippy-box[data-animation="perspective"][data-placement^="right"][data-state="visible"] {
          transform: perspective(700px);
        }
        &.tippy-box[data-animation="perspective"][data-placement^="right"][data-state="hidden"] {
          transform: perspective(700px) translateX(-8px) rotateY(60deg);
        }
        &.tippy-box[data-animation="perspective"][data-state="hidden"] {
          opacity: 0;
        }
      `}
      placement={placement}
      animation="perspective"
    >
      {children as any}
    </Tippy>
  )
}
